var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"sendmail"}},[_vm._v(" 이메일전송 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }